import type { Role } from "@elektr/shared";
import type { ReactNode } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { Spinner } from "@/components/ui/card";
import { STAFF_ROLES, useAuth } from "@/lib/auth";

/** Har qanday kirgan foydalanuvchi. Kirmagan bo'lsa /login ga. */
export function RequireAuth() {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner className="size-8" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ from: loc.pathname + loc.search }} />;
  return <Outlet />;
}

/** Xodimlar (admin, elektrik) paneli. Uy egalari o'z sahifasiga (/my) yo'naltiriladi. */
export function RequireStaff() {
  const { user } = useAuth();
  if (user && !STAFF_ROLES.includes(user.role)) return <Navigate to="/my" replace />;
  return <Outlet />;
}

/** Uy egasi sahifalari. Xodimlar panelga qaytariladi. */
export function RequireCustomer() {
  const { user } = useAuth();
  if (user && user.role !== "customer") return <Navigate to="/" replace />;
  return <Outlet />;
}

export function RequireRole({ roles, children }: { roles: Role[]; children: ReactNode }) {
  const { user } = useAuth();
  if (!user || !roles.includes(user.role)) return <Navigate to="/" replace />;
  return <>{children}</>;
}
